import React from 'react'
import {Icon} from '@chakra-ui/react'

const ShippingIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.5 3.5H33.5V17.5396H30.5V6.5H4.5V32.5H30.5V29.6613H33.5V35.5H1.5V3.5Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.5 5H13.5V13.6919L17.5 11.9141L21.5 13.6919V5H24.5V18.3081L17.5 15.197L10.5 18.3081V5Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M31.5 29C33.9853 29 36 26.9853 36 24.5C36 22.0147 33.9853 20 31.5 20C29.0147 20 27 22.0147 27 24.5C27 26.9853 29.0147 29 31.5 29ZM31.5 32C35.6421 32 39 28.6421 39 24.5C39 20.3579 35.6421 17 31.5 17C27.3579 17 24 20.3579 24 24.5C24 28.6421 27.3579 32 31.5 32Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M29.3975 22.2941H31.3975V24.8235H33.9269V26.8235H29.3975V22.2941Z"
                fill="black"
            />
        </Icon>
    )
}

export default ShippingIcon
